import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../public/img/ZBEdge-LO-lightBG.png'


const _hoisted_1 = { id: "PreLoginPage" }
const _hoisted_2 = { id: "AzureTemplatePageInner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "titleSection" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "logoWrap" }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "logo",
      src: _imports_0,
      alt: "mymobility"
    })
  ])
], -1)
const _hoisted_4 = { id: "loginSection" }
const _hoisted_5 = { id: "loginBox" }
const _hoisted_6 = { id: "loginBoxInner" }
const _hoisted_7 = {
  id: "welcomeText",
  class: "bottomSpaceDouble heading"
}
const _hoisted_8 = {
  key: 0,
  class: "alertBox bottomSpace"
}
const _hoisted_9 = { class: "section" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = ["for"]
const _hoisted_12 = {
  key: 0,
  class: "error"
}
const _hoisted_13 = { class: "bottomSpaceDouble section" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["disabled", "value", "data-testid"]
const _hoisted_17 = {
  key: 0,
  class: "error"
}
const _hoisted_18 = { class: "button-section" }
const _hoisted_19 = {
  id: "newUserStartHere",
  href: "/find-invites"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              id: "preloginForm",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('redeem_invite_login_button')), 1),
              (_ctx.errorDisplayKey)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t(_ctx.errorDisplayKey)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", { for: _ctx.email }, _toDisplayString(_ctx.$t('email_address')), 9, _hoisted_11)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    name: "email",
                    type: "email",
                    autocomplete: "on",
                    class: "emailInput editProfileInput",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                (_ctx.emailError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.emailError), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", { for: _ctx.selectedCountry }, _toDisplayString(_ctx.$t('select_country_prelogin')), 9, _hoisted_15)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                    autocomplete: "on",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CountrySelected())),
                    "data-testid": "countrySelector"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                      return (_openBlock(), _createElementBlock("option", {
                        disabled: country.id === 0,
                        key: country.id,
                        value: country,
                        "data-testid": country.abbreviation
                      }, _toDisplayString(country.name), 9, _hoisted_16))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedCountry]
                  ])
                ]),
                (_ctx.countryError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.countryError), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: "button",
                  type: "submit",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SubmitForLogin && _ctx.SubmitForLogin(...args)))
                }, _toDisplayString(_ctx.$t('redeem_invite_validate_phone_button')), 1)
              ]),
              _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.$t('new_user_start_here')), 1)
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}